import { jsx as _jsx } from "react/jsx-runtime";
import { Tag } from 'antd';
export const TagRenderComponent = ({ props, color }) => {
    const tagRender = (props) => {
        const { label, value, closable, onClose } = props;
        const onPreventMouseDown = (event) => {
            event.preventDefault();
            event.stopPropagation();
        };
        return (_jsx(Tag, { color: color, onMouseDown: onPreventMouseDown, closable: closable, onClose: onClose, style: { marginInlineEnd: 4 }, children: label }));
    };
    return tagRender(props);
};
